import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import WarnUnsavedChangesInsideApp from '~/components/warningUnsavedChanges/warnUnsavedChangesInsideApp'
import useWarningUnsavedChangesOnAppClose from '~/components/warningUnsavedChanges/warnUnsavedChangesOutsideApp'
import PartnerThemeWrapper from '~/features/partners/components/partnerThemeWrapper'
import { EAdminPortalClientPath } from '~/models/api'
import { sessionStore } from '~/store'

function WarningUnsavedChanges() {
  const showWarning = sessionStore((state) => state.UIElements.showWarning)
  const location = useLocation()
  useWarningUnsavedChangesOnAppClose({ shouldDisplayWarning: showWarning })

  const isNonPartnerPath = useMemo(
    () => location.pathname.startsWith(EAdminPortalClientPath.admin),
    [location.pathname],
  )

  if (isNonPartnerPath) {
    return <WarnUnsavedChangesInsideApp shouldDisplayWarning={showWarning} />
  }

  return (
    <PartnerThemeWrapper>
      <WarnUnsavedChangesInsideApp shouldDisplayWarning={showWarning} />
    </PartnerThemeWrapper>
  )
}
export default WarningUnsavedChanges
